<div class="full-height flex-column gap-24">
  <div class="flex-column gap-16 flex-grow">
    <h2>{{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: SHIFT_TRANSLATION_KEY | bmsTranslate: {count: 1} | lowercase} }}</h2>
    <form class="flex-column gap-8 flex-grow" [formGroup]="addPatternShiftForm">
      <mat-form-field class="full-width">
        <mat-label>{{ 'CALENDAR.SHIFT.SHIFT_CODE' | bmsTranslate: {count: 1} }}</mat-label>
        <vdw-object-selection
          formControlName="shift"
          [objectName]="'CALENDAR.SHIFT.SHIFT_CODE' | bmsTranslate: {count: 1} | lowercase"
          [canShowMultiSelectPlaceHolder]="false"
          [canShowBMSTheme]="true"
          [withDialogObjectSelection]="true"
          (selectClicked)="selectShift()"
        ></vdw-object-selection>
        <mat-error *vdwCanShowErrorForFormControl="'shift'; error: 'required'">
          <vdw-invalid-form-message [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
        </mat-error>
      </mat-form-field>
      <div class="flex-row gap-16">
        <vdw-time-picker-form-input class="full-width" [label]="'GENERAL.DATETIME.START_TIME' | bmsTranslate" [notation]="24" [form]="addPatternShiftForm" controlName="startTime" placeholder="06:00">
          <ng-container error>
            <vdw-invalid-form-message *vdwCanShowErrorForFormControl="'startTime'; error: 'required'" [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
            <vdw-invalid-form-message
              *vdwCanShowErrorForFormControl="'startTime'; error: 'overlappingShifts'"
              [message]="'CALENDAR.ERROR.OBJECT_CANT_OVERLAP' | bmsTranslate: {object: SHIFT_TRANSLATION_KEY | bmsTranslate: {count: 2}}"
              [compact]="true"
            ></vdw-invalid-form-message>
          </ng-container>
        </vdw-time-picker-form-input>
        <vdw-time-picker-form-input class="full-width" [label]="'GENERAL.DATETIME.END_TIME' | bmsTranslate" [notation]="24" [form]="addPatternShiftForm" controlName="endTime" placeholder="22:00">
          <ng-container error>
            <vdw-invalid-form-message *vdwCanShowErrorForFormControl="'endTime'; error: 'required'" [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
            <vdw-invalid-form-message
              *vdwCanShowErrorForFormControl="'endTime'; error: 'overlappingShifts'"
              [message]="'CALENDAR.ERROR.OBJECT_CANT_OVERLAP' | bmsTranslate: {object: SHIFT_TRANSLATION_KEY | bmsTranslate: {count: 2}}"
              [compact]="true"
            ></vdw-invalid-form-message>
          </ng-container>
        </vdw-time-picker-form-input>
      </div>
      <div class="flex-column gap-4 flex-grow">
        <p class="b2">{{ 'CALENDAR.BREAK' | bmsTranslate: {count: 2} }}</p>
        <ag-grid-angular class="full-width full-max-height ag-auto-grow-grid-height" [rowData]="breaksConfig.rowData" [gridOptions]="breaksConfig.gridOptions" />
        <button mat-button (click)="addBreak()">
          <mat-icon svgIcon="solid-add"></mat-icon>
          {{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'CALENDAR.BREAK' | bmsTranslate: {count: 1} | lowercase} }}
        </button>
      </div>
    </form>
  </div>
  <vdw-footer
    [centered]="true"
    [chooseEventName]="'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: SHIFT_TRANSLATION_KEY | bmsTranslate: {count: 1} | lowercase}"
    (chooseEvent)="addPatternShift()"
    (cancelEvent)="cancel()"
  ></vdw-footer>
</div>
